import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { Form, Col } from 'react-bootstrap';

interface ComentarioExpandivelProps {
	name: string;
	register?: any;
	control?: any;
	valorInicial?: string | null;
	label?: string;
	placeholder?: string;
	rows?: number;
}

export default function ComentarioExpandivel({
	name,
	register,
	control,
	valorInicial,
	label = 'Se pertinente comentar:',
	placeholder = 'Comentários',
	rows = 2,
}: ComentarioExpandivelProps) {
	const [expandido, setExpandido] = useState(() => !!(valorInicial && String(valorInicial).trim()));
	const idCampo = `comentario-${name}`;

	useEffect(() => {
		if (valorInicial && String(valorInicial).trim()) {
			setExpandido(true);
		}
	}, [valorInicial]);

	const campoTexto = control ? (
		<Controller
			control={control}
			name={name as any}
			render={({ value, onChange }) => (
				<Form.Control
					as="textarea"
					rows={rows}
					placeholder={placeholder}
					value={value ?? ''}
					onChange={(event) => onChange(event.target.value)}
				/>
			)}
		/>
	) : (
		<Form.Control as="textarea" rows={rows} ref={register} name={name} placeholder={placeholder} />
	);

	return (
		<Form.Row className="row-custom">
			<Form.Group as={Col} md={12}>
				<button
					type="button"
					className="btn btn-link p-0"
					onClick={() => setExpandido((atual) => !atual)}
					aria-expanded={expandido}
					aria-controls={idCampo}
				>
					{expandido ? 'Recolher comentários' : 'Expandir comentários'}
				</button>
				<div id={idCampo} className="mt-2" style={{ display: expandido ? 'block' : 'none' }}>
					<Form.Label>{label}</Form.Label>
					{campoTexto}
				</div>
			</Form.Group>
		</Form.Row>
	);
}
